import React, { useContext, useEffect, useRef } from "react";
import { WizardContext } from "../../index";
import Select from "react-select";

export default function LocationPicker() {
  const {
    homeLocation,
    locationType,
    setHomeLocation,
    locationError,
    setLocationError,
  } = useContext(WizardContext);
  const locationBox = locationData.filter(
    (loc) => loc.page_template_slug == ""
  );

  const selectRef = useRef(null);

  const locationOptions = locationBox.map((data) => ({
    value: data.id,
    label: data.title,
    data: {
      slug: data.slug,
      status: data.status,
      unlimitedMonthlyProductConfig: JSON.stringify(
        data.unlimited_monthly_product_config
      ),
      flexDayPassProductConfig: JSON.stringify(
        data.flex_day_pass_product_config
      ),
    },
  }));

  useEffect(() => {
    if (locationError && selectRef.current) {
      selectRef.current.focus();
    }
  }, [locationError]);

  return (
    <div className="locationPicker">
      <label className="floatingLabel">
        {locationType == "single" ? "Single space access" : "Home location"}
      </label>
      <Select
        ref={selectRef}
        isSearchable={false}
        menuPlacement="auto"
        menuPosition="fixed"
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        }}
        className={`selectBox ${locationError && "error"}`}
        classNamePrefix="value"
        options={locationOptions}
        onChange={(selectedOption) => {
          setHomeLocation(selectedOption.value);
          setLocationError(false);
        }}
        value={
          locationOptions.find(
            (option) => option.value === Number(homeLocation)
          ) || null
        }
        getOptionLabel={(e) => (
          <div data-slug={e.data.slug} data-status={e.data.status}>
            {e.label}
          </div>
        )}
        data-all-location-slug={locationOptions}
      />
      {locationError && <div className="errorBox">This field is required</div>}
    </div>
  );
}
